<template>
	<DraggbleWindow
		v-show="isOpenFolder"
        :ref="refName"
		class="folder"
		:style="getRootStyles"
		:hasPanel="false"
		:title="title"
        :isMinimize="isMinimize"
        :isRename="isRename"
        :color="color"
        :isResized="!isFolderFiftySize"
		@mousedown.native="bringToFront(id)"
		@onMinimized="collapseFolder(id)"
		@onClose="closeFolder(id)"
        @onRenameWindow="onRenameFolder"
        @onResize="$emit('onResize')"
        @onResized="onChangeSizeFolder"
        @onMoved="onChangePositionFolder"
    >
        <template v-slot:panel>
            <slot name="panel" />
        </template>
		<template v-slot:summary>
            <slot name="summary" />
        </template>
        <template v-slot:content>
            <div class="folder__content">
                <slot name="content" />
            </div>
        </template>
	</DraggbleWindow>
</template>

<script>
import {mapGetters, mapMutations} from 'vuex'
import DraggbleWindow from '../DraggbleWindow'

export default {
	name: "Folder",
	components: {
		DraggbleWindow
	},
	props: {
		id: {
			type: [String, Number],
			required: true
		},
		title: {
			type: String,
			default: "Folder"
		},
		width: {
			type: String,
			default: '400px'
		},
		height: {
			type: String,
			default: '300px'
		},
		top: {
			type: String,
			default: '80px'
		},
		left: {
			type: String,
			default: '10px'
		},
        isMinimize: {
            type: Boolean,
            default: true
        },
        isRename: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: ''
        },
        isFolderFiftySize: {
            type: Boolean,
            default: false
        }
	},
    /**
     * Данные компонента
     * @property {Array} folderParams - параметры всех папок
     * @property {Object} folderParam - параметры папки
     */
    data: () => ({
        folderParams: [],
        folderParam: {},
    }),

    created() {
        const params = localStorage.getItem('folderParams') ?? [];

        if (params.length > 0) {
            this.folderParams = JSON.parse(params);
            this.folderParam = this.folderParams.find((folder) => String(folder.id) === String(this.id)) ?? {};
        }
    },

    updated() {
        if (this.isOpenFolder) {
            const rect = this.$refs[this.refName]?.$el?.getBoundingClientRect() ?? {};

            if (rect.left > window.innerWidth + 5 || rect.right > window.innerWidth + 5) {
                this.changeAllFolderParams('400px', '300px', 0, 0);
                this.closeFolder(this.id);
                this.openFolder(this.id);
            }
        }

        // const [ widthSize = '' ] = this.folderParam?.size ?? [];

        // const isWidthSizeNumber = !isNaN(parseFloat(widthSize));
        // const isWidthSizePx = /px$/.test(String(widthSize));

        // if (isWidthSizeNumber || isWidthSizePx) {
        //     const windowInnerWidth = window.innerWidth
        //     const widthSizeNumber = parseFloat(String(widthSize).replace(/\D/g, ''));

        //     if (windowInnerWidth <= widthSizeNumber) {
        //         this.folderParam = {
        //             ...this.folderParam,
        //             size: [
        //                 '400px',
        //                 '300px'
        //             ]
        //         };
        //     }
        // }
    },

	computed: {
		...mapGetters('folders', [
            'folders',
            'expandedFolders',
            'folderQueue',
        ]),

        currentFolderResize() {
            const currentFolder = this.folders.find((folder) => String(folder.id) === String(this.id)) ?? {};
            const { resize = '' } = currentFolder;

            return resize;
        },

		getRootStyles() {
            // const currentFolder = this.folders.find((folder) => String(folder.id) === String(this.id)) ?? {};
            // const { resize = '' } = currentFolder;
            const { position, size = [] } = this.folderParam;
            const [ widthSize = '400px', heightSize = '300px' ] = size;

            let width = widthSize === '400px' ? this.width : widthSize;
            let height = heightSize === '300px' ? this.height : heightSize;
            let left = !Array.isArray(position) ? this.left : position[0];
            let top = !Array.isArray(position) ? this.top : position[1];

            // if (resize === 'full') {
            if (this.currentFolderResize === 'full') {
                width = '100vw';
                height = 'calc(100vh - 153px)';
                top = '80px';
                left = '0';

                this.changeAllFolderParams(width, height, left, top);
            }

            // if (resize === 'fifty') {
            if (this.currentFolderResize === 'fifty' || this.isFolderFiftySize) {
                // width = '50vw';
                width = '100%';
                // height = 'calc(100vh - 153px)';
                height = '100%';
                // top = '80px';
                top = '0';
                // left = '50vw';
                left = '0';

                this.changeAllFolderParams(width, height, left, top);
            }

            // if (resize === 'minimize') {
            if (this.currentFolderResize === 'minimize') {
                width = '50vw';
                height = '30vw';
                // top = '80px';
                top = '0';
                left = '10px';

                this.changeAllFolderParams(width, height, left, top);
            }

			return {
				width,
				height,
				top,
				left,
				zIndex: 5 + this.folderQueue.indexOf(this.id),
			}
		},

		/**
		 * @returns {Boolean} является ли папка открытой
		 */
		isOpenFolder() {
			return this.expandedFolders.findIndex(item => item.id === this.id) != -1
		},

        refName() {
            return `DraggbleWindow-${this.id}`;
        }
	},
	methods: {
		...mapMutations('folders', [
			'closeFolder',
            'openFolder',
			'bringToFront',
			'collapseFolder',
			// 'setFolderData',
            'toggleResizeFolder'
		]),

        /**
         * Событие переименования папки
         * @param {String} newName - новое имя
         */
        onRenameFolder(newName = '') {
            this.$emit('onRenameFolder', this.id, newName);
        },

        /**
         * Событие перемещения папки
         * @param {String} left
         * @param {String} top
         */
        onChangePositionFolder(left, top) {
            this.toggleResizeFolder({id: this.id, resize: ''});
            this.folderParam = {...this.folderParam, id: this.id, position: [left, top] };
            this.saveFolderParams(this.folderParam);
        },

        /**
         * Событие ресайза папки
         * @param {String} width
         * @param {String} height
         */
        onChangeSizeFolder(width, height) {
            this.toggleResizeFolder({id: this.id, resize: ''});
            const { size = [] } = this.folderParam ?? {};
            const [w , t] = size;

            if (t === '0' || w === '0') { return }

            this.folderParam = {...this.folderParam, id: this.id, size: [width, height] };
            this.saveFolderParams(this.folderParam);
        },

        /**
         * Событие ресайза папки половина экрана/полный экран
         * @param {String} width
         * @param {String} height
         * @param {String} left
         * @param {String} top
         */
        changeAllFolderParams(width, height, left, top) {
            this.folderParam = { id: this.id, position: [left, top], size: [width, height] };
            this.saveFolderParams(this.folderParam);
        },

        /**
         * Событие сохранения координат в LocalStorage
         * @param {Object} currentFolder - параметры папки
         */
        saveFolderParams(currentFolder = {}) {
            const params = localStorage.getItem('folderParams') ?? [];

            if (params.length > 0) {
                this.folderParams = JSON.parse(params);
            }

            let dublicateFolderIndex = this.folderParams.findIndex((folder) => String(folder.id) === String(this.id));
            if (dublicateFolderIndex !== -1) {
                this.folderParams.splice(dublicateFolderIndex, 1, currentFolder);
            } else {
                this.folderParams.push(currentFolder);
            }

            localStorage.setItem('folderParams', JSON.stringify(this.folderParams));
        },
	}
}
</script>

<style lang="scss" scoped>
.folder {
	box-shadow: 9px 19px 40px #0000001C;
	border-radius: 10px;
	z-index: 1000;

	&__content {
		height: 100%;
		width: 100%;
		overflow: hidden;
        background: #fff;
	}
}
</style>
